import { __assign } from '../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

var MenuIcon = forwardRef(function (props, ref) {
    return (React.createElement(SvgIcon, __assign({}, props, { ref: ref }),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "23", height: "18", viewBox: "0 0 23 18" },
            React.createElement("g", { "data-name": "Group 9056" },
                React.createElement("g", { "data-name": "Group 8982" },
                    React.createElement("path", { "data-name": "Line 311", transform: "translate(1 .999)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2px", d: "M0 0h21" }),
                    React.createElement("path", { "data-name": "Line 312", transform: "translate(1 8.999)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2px", d: "M0 0h21" }),
                    React.createElement("path", { "data-name": "Line 313", transform: "translate(1 16.999)", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2px", d: "M0 0h21" }))))));
});

export { MenuIcon };
//# sourceMappingURL=MenuIcon.js.map
